export const diStrategy = {
  title: 'DI strategies',
  diStrategyClassLabel: '{{label}}. {{name}}',
  diStrategyLabel:
    '{{diStrategyClassLabel}}{{diStrategyLabelNumber}}. {{diStrategyName}}',
  tags: 'Corresponding characteristics',
  video: 'DI strategies lesson videos',
  furtherReadingAndExamples: 'Examples and extended readings',
}
